import $ from 'jquery';

export function getDimensions(element: JQuery | HTMLElement, options?) {
  let $element = $(element);
  if (!options) {
    options = {
      inner: true
    }
  }
  prepareDimensions($element);
  let dimensions = {
    width: (options.inner) ? $element.width() : undefined,
    height: (options.inner) ? $element.height() : undefined,
    outerWidth: (options.outer) ? $element.outerWidth() : undefined,
    outerHeight: (options.outer) ? $element.outerHeight() : undefined
  };
  restoreDimensions($element);
  return dimensions;		
};


export function restoreDimensions(element: JQuery | HTMLElement) {
  let $element = $(element);
  let dimensionsObject;
  let $dimensionsRoot: JQuery;
  
  $element.parents().addBack().each(function() {
    var $parent = $(this);
    if (dimensionsObject = $parent.data('_pkdim')) {
      $dimensionsRoot = $parent;
      return false;
    }
  });
  
  if (dimensionsObject) {
    // Revert to display none
    // (first check if it is hidden if we unset "display", since we don't want to override css)
    dimensionsObject.$hiddenElements.each(function() {
      var $this = $(this);
      $this.css('display', '');
      if ($this.css('display') !== 'none') {
        $this.css('display', 'none');
      }
    });
    $dimensionsRoot.css(dimensionsObject.postCss);
    $dimensionsRoot.removeData('_pkdim');
  }
  
  return this;
};


export function prepareDimensions(element: JQuery | HTMLElement) {
  let $element = $(element);
  let $hiddenThis = $element.filter(function() { return ($(this).css('display') == 'none'); });
  let $hiddenParents = $element.parents().filter(function() { return ($(this).css('display') == 'none'); });
  let $hiddenElements = $hiddenThis.add($hiddenParents);
  let $hiddenRoot = $hiddenElements.last();
  let $wideDummy;
  let preCss;
  let postCss;
  
  function checkStyle(key) {
      preCss[key] = $hiddenRoot.css(key);
      $hiddenRoot.css(key, '');
      if (preCss[key] !== $hiddenRoot.css(key)) {
        postCss[key] = preCss[key];
      } else {
        postCss[key] = '';
      }			
  };
  
  if (!$element.data('_pkdim') && $hiddenElements.length > 0) {
    if ($hiddenElements.length > 1) {
      $hiddenElements.not($hiddenRoot).show();
    }
    
    preCss = {};
    postCss = {};
    
    // Split into read/write passes to avoid reflows
    checkStyle('position');
    checkStyle('top');
    checkStyle('right');
    checkStyle('bottom');
    checkStyle('left');
    checkStyle('transition');
    
    preCss.float = $hiddenRoot.css('float');
    
    $hiddenRoot.css('position', 'absolute');
    
    // Move vertically out of screen
    if (preCss.top !== 'auto') {
      $hiddenRoot.css('top', parseFloat(preCss.top) - 99999);
    } else if (preCss.bottom === 'auto') {
      $hiddenRoot.css('top', -99999);
    }
    if (preCss.bottom !== 'auto') {
      $hiddenRoot.css('bottom', parseFloat(preCss.bottom) + 99999);
    }
    
    // Move horizontally out of screen
    if (preCss.left !== 'auto') {
      $hiddenRoot.css('left', parseFloat(preCss.left) - 99999);
    } else if (preCss.right === 'auto') {
      $hiddenRoot.css('left', -99999);
    }
    if (preCss.right !== 'auto') {
      $hiddenRoot.css('right', parseFloat(preCss.right) + 99999);
    }
    
    $hiddenRoot.show();

    // A block element will by default have 100% width, but not now since it's position: absolute.
    // Set width to 100% if it's width is dynamic. ($.css('width') won't tell if a percentage or px value is set)
    if (preCss.position !== 'absolute' && preCss.float === 'none' && $hiddenRoot.css('display') === 'block' && (preCss.left === 'auto' || preCss.right === 'auto')) {
      var hiddenWidth = $hiddenRoot.width();
      $wideDummy = $(document.createElement('div')).css('width', hiddenWidth + 1);
      $hiddenRoot.append($wideDummy);
      // Width is dynamic, because of position
      if ($hiddenRoot.width() > hiddenWidth) {
        postCss.width = '';
        $hiddenRoot.css('transition', 'all 0s');
        $hiddenRoot.css('width', '100%');
      }
      $wideDummy.remove();
    }
    
    $hiddenRoot.data('_pkdim', {
      $hiddenElements: $hiddenElements,
      postCss: postCss 
    });
  }

  return this;
};
